import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import WarrantyErrorCodes from './warrantyErrorCodes/list';
import WarrantyErrorCodesForm from './warrantyErrorCodes/edit';
import WarrantyTasksCodes from './warrantyTasksCodes/list';
import WarrantyTasksCodesForm from './warrantyTasksCodes/edit';

export const twcMaintenanceRoutes = [
  {
    'component': <WarrantyErrorCodes />,
    'path': paths.WarrantyErrorCodes,
  },
  {
    'component': <WarrantyErrorCodesForm />,
    'path': paths.WarrantyErrorCodesEdit,
  },
  {
    'component': <WarrantyErrorCodesForm />,
    'path': paths.WarrantyErrorCodesNew,
  },
  {
    'component': <WarrantyTasksCodes />,
    'path': paths.WarrantyTasksCodes,
  },
  {
    'component': <WarrantyTasksCodesForm />,
    'path': paths.WarrantyTaskCodesEdit,
  },
  {
    'component': <WarrantyTasksCodesForm />,
    'path': paths.WarrantyTaskCodeNew,
  },
];
